export default __webpack_public_path__ + "static/default-4_500x500-586d051a23ff2257169b8dcf291c65d2.png";